export default `---
slug: russia
country: Russia
countryCode: RUS
continent: Europe
year: 2018
title: "Russia — St. Petersburg with the Family"
description: "A family week in St. Petersburg: the Winter Palace, a ferry to Peterhof, metro stations that belong in a museum, and vodka served the correct way."
thumbnail: /images/travels/RUS/russia_thumb.jpg
relatedLinks: []
---

Before COVID made long-distance travel complicated, my family took a week in <b>St. Petersburg</b> — both parents, my brothers, my aunt, uncle, and cousin. The full contingent.

I should also mention that we flew <i>business class</i>. My dad had accumulated Lufthansa miles over years of work travel and used them to upgrade everyone. This was my first time flying business class. I'm not going to pretend it didn't affect my impression of the overall trip.

## The City

St. Petersburg was built fast, built deliberately, and it shows. The entire city centre feels like it was designed by the same committee in the same decade — which, give or take, it was, under Peter the Great in the early 1700s. The result is a city of unusual visual coherence: grand, European, and a bit overwhelming in its consistency.

The <b>Winter Palace</b> lives up to its reputation. Enormous, lavishly decorated, genuinely historic. We went through it properly — which takes a while — and came out appropriately impressed.

## Peterhof

One day we took a ferry along the Gulf of Finland to <b>Peterhof</b>, the palace complex outside the city, sometimes called the Russian Versailles. It's not quite Versailles and it's certainly not the Reggia di Caserta, but it is very large and very grand — formal gardens cascading down toward the sea, an extravagant number of fountains, and the unmistakable energy of a place built by someone who had heard about Versailles and decided to have a go. <b>The ferry approach to it is worth it on its own.</b>

## The Metro

The St. Petersburg metro is extraordinary. I normally pay zero attention to subway stations, but these are impossible to ignore: <b>marble walls, chandeliers, mosaics, socialist realist paintings</b> at every major stop. Each station is its own architectural statement. We went out of our way to visit a few of them purely as destinations, the way you'd visit a museum gallery.

## Vodka, the Correct Way

Russians drink vodka with food — specifically, alongside soup. A small glass of very cold vodka with a bowl of borscht is a genuinely good pairing that I did not expect to enjoy as much as I did.

One evening, my dad and I had a glass at the hotel bar from a particularly good bottle — premium, expensive, smooth in a way that made complete sense of why Russians are so loyal to the thing. <i>That was a good evening.</i>

One week in one city is not enough to say much about Russia as a country, and the situation has obviously changed considerably since this trip. But St. Petersburg itself was worth the journey — and worth the business class seat on the way there.
`;
